import {
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import {
  menuUtil,
  useAccessState
} from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import {
  RemoveStandardAreaInstallationModal,
  SaveStandardAreaInstallationModal
} from 'modules/components/layer17';
import React, { useState } from 'react';

export type StandardAreaInstallationMenuProps = menuUtil.IBaseMenuProps & {};

export const FC = (props: StandardAreaInstallationMenuProps) => {
  const theme = useTheme();
  const [
    isSaveVisible,
    setIsSaveVisible
  ] = useState<boolean>(false);

  const [
    isRemoveVisible,
    setIsRemoveVisible
  ] = useState<boolean>(false);

  return (
    <>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        id={props.id}
        open={props.open}
        anchorEl={props.anchorEl ?? null}
        onClose={() => props.handleClose()}
      >
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsSaveVisible(() => true);
          }}
        >
          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='EDIT'
              stroke={theme.palette.primary.main}
            />
            <Typography
              variant='menuItem'
              color={(theme) => {
                return theme.palette.primary.main;
              }}
            >
              Edit
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsRemoveVisible(() => true);
          }}
        >
          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='DELETE'
              stroke={theme.palette.error.main}
            />
            <Typography
              variant='menuItem'
              color={(theme) => {
                return theme.palette.error.main;
              }}
            >
              Remove Template
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
      {isSaveVisible && (
        <SaveStandardAreaInstallationModal.FC
          id={props.id}
          isVisible={isSaveVisible}
          handleClose={() => setIsSaveVisible(() => false)}
        />
      )}
      {isRemoveVisible && (
        <RemoveStandardAreaInstallationModal.FC
          id={props.id}
          isVisible={isRemoveVisible}
          handleClose={() => setIsRemoveVisible(() => false)}
        />
      )}
      {/* MODALS HERE */}
    </>
  );
};
